import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

// models
import Message from '../models/Message';
import { Option, CardResponse } from '../models/Conversation';





const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: 315, // TO ADJUST VIA MEDIA QUERY
        },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
        }
  }));

const MessageCard = (props:any) => {
    const classes = useStyles();
    const message:Message = props.message
    const card: CardResponse = message.messageData;
    return (
        <Card className={classes.root}>
            <a href={card.actions[0] !== undefined ? card.actions[0].value : "https://www.bankofbaroda.co.in"} target="_blank" rel="noreferrer">
                <CardMedia
                    className={classes.media}
                    image={card.media.source}
                    title={card.title}
                />
            </a>
            <CardHeader
                title={card.title}
                titleTypographyProps={{variant: "h6"}}
                subheader=""
            />
            
            <CardContent>
                <Typography variant="body2" color="textSecondary" component="p">
                    {card.description}
                </Typography>
            </CardContent>
            <CardActions>
                <Box display="flex" flexGrow={1} justifyContent="flex-start" alignContent="flex-center">
                    {card.actions.map((option:Option) => {
                        return (
                            <Button variant="text" color="primary" size="small" href={option.value} target="_blank" rel="noopener">
                                {option.label}
                            </Button>
                        );
                    })}
                </Box>
            </CardActions>
        </Card>
      );
};

export default MessageCard;